// use localStorage to keep value
export const getToken = () => {

        //const cookies = new Cookies();
        //return cookies.get('token');
    return localStorage.getItem("token");
}

export const saveToken = (token) => {

    //const cookies = new Cookies();
    //cookies.set("token",language,{path: '/'});
    localStorage.setItem("token",token);
}

export const removeToken = () => {
    localStorage.removeItem("token");
}